import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTASection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-bg-card border-t border-border-color text-center" data-id="element-44">
      <div className="container max-w-3xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-46">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-text-primary mb-6" data-id="element-47">
            No necesitás ser alguien más. <br data-id="element-48" />
            <span className="text-accent" data-id="element-49">Necesitás ser consistente.</span>
          </h2>
          <p className="text-lg text-text-secondary mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-50">
            Si estás cansado de improvisar, compararte y sentir que "te falta
            eso", este es tu punto de partida. El Método Magnético te da
            estructura, práctica y claridad para que tu presencia hable por vos.
          </p>

          <CTAButton href="https://pay.hotmart.com/D103645894Y?checkoutMode=10" className="mx-auto text-lg px-10 py-5" data-id="element-51">
            QUIERO EMPEZAR HOY
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}